exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar[data-v-80ede286] {\n  height: 20px;\n  width: 20px;\n  vertical-align: middle;\n  margin-top: -2px;\n}\n", ""]);

// exports
